var React = require('react');

function CheetohLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.48888 23.5605C8.27537 22.9977 13.2877 19.5495 14.4158 20.4525","stroke":"#FF8200","strokeWidth":"3.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.43271 10.8306C8.45011 11.1315 10.7347 11.9471 12.6937 11.7933","stroke":"#FF8200","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M9.53439 1.77148C11.2955 2.31621 12.6025 2.96347 13.9626 4.15568","stroke":"#FF8200","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CheetohLeft.defaultProps = {"width":"21","height":"26","viewBox":"0 0 21 26","fill":"none"};

module.exports = CheetohLeft;

CheetohLeft.default = CheetohLeft;
